@if (backBtn) {
  <button (click)="backClick()" class="wizard-btn btn-secondary" data-cy="wizard-footer-button-back">
    Back
  </button>
}

@if (!finishBtn) {
  <button (click)="continueClick()" [disabled]="disableContinue"
    class="wizard-btn btn-primary align-right" data-cy="wizard-footer-button-continue">Continue
  </button>
}

@if (closeBtn && finishBtn) {
  <button (click)="closeClick()" class="wizard-btn btn-primary align-right"
    data-cy="wizard-footer-button-close">Close
  </button>
}

@if (userService.hasPermissions([
  Permission.PARTNER_SPO_CREATE_SEND,
  Permission.PARTNER_CLAIM_CREATE_SEND
  ]) && sendBtn && finishBtn) {
  <button (click)="sendClick()"
    [disabled]="disableSend"
    class="wizard-btn btn-primary align-right"
    data-cy="wizard-footer-button-send">Send
  </button>
}

<button (click)="save()" [disabled]="disableSave" class="wizard-btn btn-secondary align-right"
  data-cy="wizard-footer-button-save">Save
</button>

<button (click)="discard()" class="wizard-btn btn-text-link align-right" data-cy="wizard-footer-button-discard">
  <span class="text">Discard</span>
</button>
